import util from '@bmp-vue/core/api/util'

const controller = 'SignUp'
export default Object.assign({}, util.GetCrud(controller, null))
